import React, { ReactNode } from 'react'
import { Square } from '../../utility/square/Square'
import { IconButton } from '../../buttons/icon-button/IconButton'
import { IconCrossBold } from '../../icons/IconCrossBold'
import { useOutsideClick } from '../../../lib/hooks/UseOutsideClick'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { selectModals } from '../../../../app/store/reducers/AppSlice'
import { BpButton } from '../../buttons/bp-button/BpButton'
import { IconArrowBack } from '../../icons/IconArrowBack'
import { useTranslation } from 'react-i18next'

export interface IBpModalProps {
  layer: number
  id?: string
  children: ReactNode
  className?: string
  size?: 'md' | 'lg' | 'xl' | 'full'
  withBackButton?: boolean
  width?: number
  onClose?: () => void
  scroll?: boolean
}

export const BpModal = ({
  layer,
  id,
  children,
  className,
  size = 'md',
  withBackButton = false,
  width,
  scroll = false,
  onClose,
}: IBpModalProps) => {
  const { t } = useTranslation()
  const modals = useAppSelector(selectModals)

  const clickRef = useOutsideClick(() => {
    modals.length === layer && onClose && onClose()
  })

  return (
    <div
      className={`fixed z-40 flex h-full w-full items-center justify-center bg-focus-500/50 py-[8px] indent-0 ${size === 'full' && 'py-0'} ${scroll ? '!items-start overflow-y-auto' : 'overflow-hidden'} `}
      id={id}
      role='dialog'
    >
      <div
        ref={clickRef}
        className={`flex w-full ${
          {
            md: 'max-w-[400px]',
            lg: 'max-w-[700px]',
            xl: 'max-w-[830px]',
            full: 'h-screen w-screen',
          }[size]
        } ${scroll ? '' : 'max-h-full'} `}
        style={{ maxWidth: width || 'auto' }}
      >
        <Square
          className={`relative flex min-h-[200px] w-full flex-col ${size === 'full' && 'rounded-none'} ${className} `}
        >
          <div className={'absolute top-0 w-full'}>
            {withBackButton && (
              <BpButton
                className={'absolute top-[16px] left-[16px] z-10 table'}
                iconLeft={<IconArrowBack />}
                size='sm'
                theme='outline'
                onClick={onClose}
              >
                {t('buttons.back')}
              </BpButton>
            )}
            <IconButton className='absolute top-[16px] right-[16px] z-10' onClick={onClose}>
              <IconCrossBold color='#6684A7' />
            </IconButton>
          </div>
          {children}
        </Square>
      </div>
    </div>
  )
}
